import Vue from 'vue'
import Router from 'vue-router'


import FormView from '@/FormView'

import MCThankYouView from '@/MCThankYouView'
import MCLoginPage from '@/MCLoginPage'
import ZetosCalcView from '@/ZetosCalcView'
import ZetosResignView from '@/ZetosResignView'
import ZetosRejectView from '@/ZetosRejectView'
import MCClientView from '@/MCClientView'
import MCProposalView from '@/MCProposalView'
import CFTimeoutPage from '@/CFTimeoutPage'

import AuthologicReturn from '@/AuthologicReturn'

import ZetosKontoxView from '@/ZetosKontoxView'
import TransactionlinkView from '@/TransactionlinkView'
import InfoClauseView from '@/InfoClauseView'
import loanPaidView from "@/loanPaidView";

import { bus } from '@/main';


Vue.use(Router);

export const router = new Router({
  routes: [

   {
      path: '/',
      alias: ['/quickform', '/verifycode', '/fullform', '/kontox', '/register'],
      name: 'ZetosFormView',
      component: FormView

    },
    {
      path: '/login',
      name: 'MCLoginPage',
      component: MCLoginPage
    },
    {
      path: '/authologic',
      name: 'AuthologicReturn',
      component: AuthologicReturn
    },
    {
      path: '/thankyou',
      name: 'MCThankYouView',
      component: MCThankYouView
    },


    {
      path: '/client',
      name: 'MCClientView',
      component: MCClientView
    },

    {
      path: '/proposal',
      name: 'MCProposalView',
      component: MCProposalView
    },

    {
      path: '/resign',
      name: 'ZetosResignView',
      component: ZetosResignView
    },

    {
      path: '/calc',
      name: 'ZetosCalcView',
      component: ZetosCalcView
    },

    {
      path: '/info',
      name: 'InfoClauseView',
      component: InfoClauseView
    },

    {
      path: '/rej',
      name: 'ZetosRejectView',
      component: ZetosRejectView
    },

    {
      path: '/pending',
      name: 'CFTimeoutPage',
      component: CFTimeoutPage
    },



    {
      path: '/t10l',
      name: 'TransactionlinkView',
      component: TransactionlinkView
    },

    {
      path:"/loanpaid",
      name:'loanPaid',
      component: loanPaidView
    },

    {
      path: '*',
      redirect: '/'
    }

  ]
});



router.beforeEach((to, from, next) => {

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/quickform', '/fullform', '/verifycode', '/register', '/t10l','/authologic', '/thankyou',  '/rej', '/proposal', '/resign', '/pending', '/calc','/info','/login','/loanpaid'];

  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');



  // default to client view after login
/*  if (loggedIn && !to.path.match(/(client|\/|fullform|rej|thankyou|proposal|pending)$/)) {


    return next('/client');
  }

  else */


  if (!loggedIn && authRequired ) {


    bus.$emit('login_dialog');

    return next('/');
  }


  next();



});



// WEBPACK FOOTER //
// ./src/router/index.js